/**
 * Multilingual UI Translations dictionary for MeetAI.
 * Natural, modern workplace & tech vocabulary across Indian languages.
 * Supported languages: English, Telugu, Hindi, Marathi, Gujarati, Tamil, Kannada, Bengali.
 */

export const TRANSLATIONS = {
  English: {
    // Nav
    instantJoin: "Instant join",
        joinMeetAi: "Invite MeetAI",
        allTranscripts: "Recorded Meetings",
    dashboard: "Dashboard",
    calendar: "Calendar",
    allMeetings: "All Meetings",
    myTasks: "My Tasks",
    collapse: "Collapse",
    expand: "Expand",

    // Header & Assistant
    searchMeetings: "Search meetings",
    askYourCompanion: "Ask your Companion",
    refresh: "Refresh",
    howItWorks: "How It Works",
    logout: "Logout",
    profile: "Profile",
    settings: "Settings",
    meetingUsage: "Meeting usage",
    feedback: "Feedback",
    appTour: "App tour",
    adminPortal: "Admin portal",

    // Time tabs & layout
    today: "Today",
    tomorrow: "Tomorrow",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    nextWeek: "Next Week",
    earlierThisWeek: "Earlier This Week",
    lastWeek: "Last Week",
    later: "Later",
    earlier: "Earlier",
    unscheduled: "Unscheduled",
    week: "Week",
    monthly: "Monthly",
    list: "List",
    grid: "Grid",
    all: "All",
    allDays: "All days",
    done: "Done",

    // Status
    upcoming: "Upcoming",
    completed: "Completed",
    live: "Live",
    ended: "Ended",
    cancelled: "Cancelled",

    // Table headers
    colMeeting: "MEETING",
    colTime: "TIME",
    colHost: "HOST",
    colParticipants: "PARTICIPANTS",
    colStatus: "STATUS",
    colAutoJoin: "AUTO JOIN",
    meetingSummary: "Meeting Summary",

    // Empty States & Filters
    noMeetingsMatchFilters: "No meetings match your filters",
    noMeetingsMatchDescAutojoin: "Invite MeetAI only shows upcoming Google Calendar events (not past or ended meetings). Open All Meetings or Recorded Meetings to see your other meetings, or widen filters below.",
    noMeetingsMatchDescGeneral: "Adjust the day, status tab, or search. Reset everything below if you want the full list again.",
    noMeetingsInView: "No meetings in view",
    noMeetingsToday: "No meetings today",
    noMeetings: "No meetings",
    allDaysAllStatuses: "All days · All statuses",
    clearSearch: "Clear search",
    loadingGoogleCalendar: "Loading Google Calendar…",

    // Toggles & Actions
    on: "On",
    off: "Off",
    rec: "REC",
    enabled: "Enabled",
    disabled: "Disabled",
    saving: "Saving…",
    edit: "Edit",
    viewing: "Viewing",
    saveChanges: "Save changes",
    cancel: "Cancel",

    // Settings modal
    manageSettingsSubtitle: "Manage your meeting preferences and defaults",
    calendarSync: "Calendar sync",
    calendarConnected: "Connected",
    calendarNeedsAttention: "Needs attention",
    meetingReminders: "Meeting reminders",
    minBefore: "min before",
    language: "Language",
    turnOnRemindersPrompt: "Turn on Meeting Reminders",
    turnOnRemindersDesc: "Get notified 10 minutes before your meetings start so you never miss a discussion.",
    maybeLater: "Maybe later",
    enableReminders: "Enable reminders",
  },

  Hindi: {
    // Nav
    instantJoin: "तुरंत जुड़ें",
        joinMeetAi: "Invite MeetAI",
        allTranscripts: "Recorded Meetings",
    dashboard: "डैशबोर्ड",
    calendar: "कैलेंडर",
    allMeetings: "सभी मीटिंग्स",
    myTasks: "मेरे टास्क",
    collapse: "छोटा करें",
    expand: "बड़ा करें",

    // Header & Assistant
    searchMeetings: "मीटिंग्स सर्च करें",
    askYourCompanion: "असिस्टेंट से पूछें",
    refresh: "रिफ्रेश",
    howItWorks: "यह कैसे काम करता है",
    logout: "लॉग आउट",
    profile: "प्रोफाइल",
    settings: "सेटिंग्स",
    meetingUsage: "मीटिंग यूसेज",
    feedback: "फीडबैक",
    appTour: "ऐप टूर",
    adminPortal: "एडमिन पोर्टल",

    // Time tabs & layout
    today: "आज",
    tomorrow: "कल",
    yesterday: "बीता कल",
    thisWeek: "इस हफ्ते",
    nextWeek: "अगले हफ्ते",
    earlierThisWeek: "इस हफ्ते पहले",
    lastWeek: "पिछले हफ्ते",
    later: "बाद में",
    earlier: "पहले",
    unscheduled: "अनशेड्यूल्ड",
    week: "हफ्ता",
    monthly: "मासिक",
    list: "लिस्ट",
    grid: "ग्रिड",
    all: "सभी",
    allDays: "सभी दिन",
    done: "पूर्ण",

    // Status
    upcoming: "आगामी",
    completed: "पूर्ण",
    live: "लाइव",
    ended: "समाप्त",
    cancelled: "रद्द",

    // Table headers
    colMeeting: "मीटिंग",
    colTime: "समय",
    colHost: "होस्ट",
    colParticipants: "प्रतिभागी",
    colStatus: "स्टेटस",
    colAutoJoin: "ऑटो जॉइन",
    meetingSummary: "मीटिंग समरी",

    // Empty States & Filters
    noMeetingsMatchFilters: "कोई मीटिंग नहीं मिली",
    noMeetingsMatchDescAutojoin: "मीट AI केवल आगामी Google कैलेंडर मीटिंग्स दिखाता है। पुरानी मीटिंग्स के लिए 'सभी मीटिंग्स' या 'सभी ट्रांसक्रिप्ट्स' देखें।",
    noMeetingsMatchDescGeneral: "दिन, स्टेटस या सर्च बदलें या नीचे सभी फ़िल्टर रीसेट करें।",
    noMeetingsInView: "कोई मीटिंग नहीं है",
    noMeetingsToday: "आज कोई मीटिंग नहीं है",
    noMeetings: "कोई मीटिंग नहीं",
    allDaysAllStatuses: "सभी दिन · सभी स्टेटस",
    clearSearch: "सर्च हटाएं",
    loadingGoogleCalendar: "Google कैलेंडर लोड हो रहा है…",

    // Toggles & Actions
    on: "ऑन",
    off: "ऑफ",
    rec: "REC",
    enabled: "चालू",
    disabled: "बंद",
    saving: "सेव हो रहा है…",
    edit: "एडिट",
    viewing: "देख रहे हैं",
    saveChanges: "बदलाव सेव करें",
    cancel: "रद्द करें",

    // Settings modal
    manageSettingsSubtitle: "अपनी मीटिंग प्राथमिकताएं और सेटिंग्स प्रबंधित करें",
    calendarSync: "कैलेंडर सिंक",
    calendarConnected: "कनेक्टेड",
    calendarNeedsAttention: "ध्यान दें",
    meetingReminders: "मीटिंग रिमाइंडर",
    minBefore: "मिनट पहले",
    language: "भाषा",
    turnOnRemindersPrompt: "मीटिंग रिमाइंडर चालू करें",
    turnOnRemindersDesc: "मीटिंग शुरू होने से 10 मिनट पहले नोटिफिकेशन पाएं।",
    maybeLater: "बाद में",
    enableReminders: "रिमाइंडर चालू करें",
  },

  Telugu: {
    // Nav
    instantJoin: "ఇన్‌స్టంట్ జాయిన్",
        joinMeetAi: "Invite MeetAI",
        allTranscripts: "Recorded Meetings",
    dashboard: "డ్యాష్‌బోర్డ్",
    calendar: "క్యాలెండర్",
    allMeetings: "అన్ని మీటింగ్స్",
    myTasks: "నా టాస్క్‌లు",
    collapse: "కుదించు",
    expand: "విస్తరించు",

    // Header & Assistant
    searchMeetings: "మీటింగ్స్ సెర్చ్ చేయండి",
    askYourCompanion: "అసిస్టెంట్‌ను అడగండి",
    refresh: "రిఫ్రెష్",
    howItWorks: "ఇది ఎలా పనిచేస్తుంది",
    logout: "లాగ్ అవుట్",
    profile: "ప్రొఫైల్",
    settings: "సెట్టింగ్స్",
    meetingUsage: "మీటింగ్ యూసేజ్",
    feedback: "ఫీడ్‌బ్యాక్",
    appTour: "యాప్ టూర్",
    adminPortal: "అడ్మిన్ పోర్టల్",

    // Time tabs & layout
    today: "ఈరోజు",
    tomorrow: "రేపు",
    yesterday: "నిన్న",
    thisWeek: "ఈ వారం",
    nextWeek: "వచ్చే వారం",
    earlierThisWeek: "ఈ వారం ప్రారంభంలో",
    lastWeek: "గత వారం",
    later: "తర్వాత",
    earlier: "మునుపటిది",
    unscheduled: "షెడ్యూల్ చేయబడలేదు",
    week: "వారం",
    monthly: "నెలవారీ",
    list: "లిస్ట్",
    grid: "గ్రిడ్",
    all: "అన్నీ",
    allDays: "అన్ని రోజులు",
    done: "పూర్తయింది",

    // Status
    upcoming: "రాబోయేవి",
    completed: "పూర్తయింది",
    live: "లైవ్",
    ended: "ముగిసింది",
    cancelled: "రద్దు చేయబడింది",

    // Table headers
    colMeeting: "మీటింగ్",
    colTime: "సమయం",
    colHost: "హోస్ట్",
    colParticipants: "పార్టిసిపెంట్స్",
    colStatus: "స్టేటస్",
    colAutoJoin: "ఆటో జాయిన్",
    meetingSummary: "మీటింగ్ సారాంశం",

    // Empty States & Filters
    noMeetingsMatchFilters: "ఫిల్టర్‌లకు సరిపోలే మీటింగ్స్ లేవు",
    noMeetingsMatchDescAutojoin: "మీట్ AI రాబోయే Google క్యాలెండర్ ఈవెంట్‌లను మాత్రమే చూపుతుంది. ఇతర మీటింగ్స్ కోసం 'అన్ని మీటింగ్స్' లేదా 'అన్ని ట్రాన్స్‌క్రిప్ట్స్' చూడండి.",
    noMeetingsMatchDescGeneral: "రోజు, స్టేటస్ లేదా సెర్చ్ మార్చండి లేదా క్రింద ఫిల్టర్‌లను రీసెట్ చేయండి.",
    noMeetingsInView: "మీటింగ్స్ ఏవీ లేవు",
    noMeetingsToday: "ఈరోజు మీటింగ్స్ లేవు",
    noMeetings: "మీటింగ్స్ లేవు",
    allDaysAllStatuses: "అన్ని రోజులు · అన్ని స్టేటస్‌లు",
    clearSearch: "సెర్చ్ క్లియర్ చేయండి",
    loadingGoogleCalendar: "Google క్యాలెండర్ లోడ్ అవుతోంది…",

    // Toggles & Actions
    on: "ఆన్",
    off: "ఆఫ్",
    rec: "REC",
    enabled: "ఆన్",
    disabled: "ఆఫ్",
    saving: "సేవ్ అవుతోంది…",
    edit: "ఎడిట్",
    viewing: "చూస్తున్నారు",
    saveChanges: "మార్పులను సేవ్ చేయండి",
    cancel: "రద్దు చేయండి",

    // Settings modal
    manageSettingsSubtitle: "మీ మీటింగ్ ప్రాధాన్యతలు మరియు సెట్టింగ్స్ నిర్వహించండి",
    calendarSync: "క్యాలెండర్ సింక్",
    calendarConnected: "కనెక్ట్ అయింది",
    calendarNeedsAttention: "శ్రద్ధ అవసరం",
    meetingReminders: "మీటింగ్ రిమైండర్స్",
    minBefore: "నిమిషాల ముందు",
    language: "భాష",
    turnOnRemindersPrompt: "మీటింగ్ రిమైండర్స్ ఆన్ చేయండి",
    turnOnRemindersDesc: "మీటింగ్ ప్రారంభానికి 10 నిమిషాల ముందు నోటిఫికేషన్ పొందండి.",
    maybeLater: "తర్వాత",
    enableReminders: "రిమైండర్స్ ఆన్ చేయండి",
  },

  Marathi: {
    // Nav
    instantJoin: "इन्स्टंट जॉइन",
        joinMeetAi: "Invite MeetAI",
        allTranscripts: "Recorded Meetings",
    dashboard: "डॅशबोर्ड",
    calendar: "कॅलेंडर",
    allMeetings: "सर्व मीटिंग्स",
    myTasks: "माझे टास्क",
    collapse: "लहान करा",
    expand: "मोठे करा",

    // Header & Assistant
    searchMeetings: "मीटिंग्स शोधा",
    askYourCompanion: "असिस्टंटला विचारा",
    refresh: "रिफ्रेश",
    howItWorks: "हे कसे कार्य करते",
    logout: "लॉग आउट",
    profile: "प्रोफाइल",
    settings: "सेटिंग्ज",
    meetingUsage: "मीटिंग वापर",
    feedback: "फीडबॅक",
    appTour: "अ‍ॅप टूर",
    adminPortal: "अ‍ॅडमिन पोर्टल",

    // Time tabs & layout
    today: "आज",
    tomorrow: "उद्या",
    yesterday: "काल",
    thisWeek: "या आठवड्यात",
    nextWeek: "पुढील आठवड्यात",
    earlierThisWeek: "या आठवड्याच्या सुरुवातीला",
    lastWeek: "गेल्या आठवड्यात",
    later: "नंतर",
    earlier: "पूर्वी",
    unscheduled: "अनशेड्युल्ड",
    week: "आठवडा",
    monthly: "मासिक",
    list: "लिस्ट",
    grid: "ग्रिड",
    all: "सर्व",
    allDays: "सर्व दिवस",
    done: "पूर्ण",

    // Status
    upcoming: "आगामी",
    completed: "पूर्ण",
    live: "थेट",
    ended: "समाप्त",
    cancelled: "रद्द",

    // Table headers
    colMeeting: "मीटिंग",
    colTime: "वेळ",
    colHost: "होस्ट",
    colParticipants: "सहभागी",
    colStatus: "स्टेटस",
    colAutoJoin: "ऑटो जॉइन",
    meetingSummary: "मीटिंग सारांश",

    // Empty States & Filters
    noMeetingsMatchFilters: "कोणत्याही मीटिंग्स आढळल्या नाहीत",
    noMeetingsMatchDescAutojoin: "मीट AI फक्त आगामी Google कॅलेंडर मीटिंग्स दाखवते. मागील मीटिंग्ससाठी 'सर्व मीटिंग्स' किंवा 'सर्व ट्रान्सक्रिप्ट्स' पहा.",
    noMeetingsMatchDescGeneral: "दिवस, स्टेटस किंवा शोध बदला किंवा खालील फिल्टर्स रीसेट करा.",
    noMeetingsInView: "कोणतीही मीटिंग नाही",
    noMeetingsToday: "आज कोणतीही मीटिंग नाही",
    noMeetings: "मीटिंग्स नाहीत",
    allDaysAllStatuses: "सर्व दिवस · सर्व स्टेटस",
    clearSearch: "शोध साफ करा",
    loadingGoogleCalendar: "Google कॅलेंडर लोड होत आहे…",

    // Toggles & Actions
    on: "चालू",
    off: "बंद",
    rec: "REC",
    enabled: "चालू",
    disabled: "बंद",
    saving: "सेव्ह होत आहे…",
    edit: "एडिट",
    viewing: "पाहत आहे",
    saveChanges: "बदल सेव्ह करा",
    cancel: "रद्द करा",

    // Settings modal
    manageSettingsSubtitle: "तुमच्या मीटिंग प्राधान्यक्रम आणि सेटिंग्स व्यवस्थापित करा",
    calendarSync: "कॅलेंडर सिंक",
    calendarConnected: "कनेक्टेड",
    calendarNeedsAttention: "लक्ष द्या",
    meetingReminders: "मीटिंग रिमाइंडर",
    minBefore: "मिनिटांपूर्वी",
    language: "भाषा",
    turnOnRemindersPrompt: "मीटिंग रिमाइंडर चालू करा",
    turnOnRemindersDesc: "मीटिंग सुरू होण्यापूर्वी 10 मिनिटे सूचना मिळवा.",
    maybeLater: "नंतर",
    enableReminders: "रिमाइंडर चालू करा",
  },

  Gujarati: {
    // Nav
    instantJoin: "ઇન્સ્ટન્ટ જોઈન",
        joinMeetAi: "Invite MeetAI",
        allTranscripts: "Recorded Meetings",
    dashboard: "ડેશબોર્ડ",
    calendar: "કેલેન્ડર",
    allMeetings: "બધી મીટિંગ્સ",
    myTasks: "મારા ટાસ્ક",
    collapse: "સંકેલો",
    expand: "વિસ્તૃત કરો",

    // Header & Assistant
    searchMeetings: "મીટિંગ્સ શોધો",
    askYourCompanion: "સહાયકને પૂછો",
    refresh: "રીફ્રેશ",
    howItWorks: "આ કેવી રીતે કામ કરે છે",
    logout: "લૉગ આઉટ",
    profile: "પ્રોફાઇલ",
    settings: "સેટિંગ્સ",
    meetingUsage: "મીટિંગ વપરાશ",
    feedback: "ફીડબેક",
    appTour: "એપ ટૂર",
    adminPortal: "એડમિન પોર્ટલ",

    // Time tabs & layout
    today: "આજે",
    tomorrow: "આવતીકાલે",
    yesterday: "ગઈકાલે",
    thisWeek: "આ અઠવાડિયે",
    nextWeek: "આવતા અઠવાડિયે",
    earlierThisWeek: "આ અઠવાડિયાની શરૂઆતમાં",
    lastWeek: "ગયા અઠવાડિયે",
    later: "પછી",
    earlier: "અગાઉ",
    unscheduled: "અનિર્ધારિત",
    week: "અઠવાડિયું",
    monthly: "માસિક",
    list: "લિસ્ટ",
    grid: "ગ્રીડ",
    all: "બધા",
    allDays: "બધા દિવસો",
    done: "પૂર્ણ",

    // Status
    upcoming: "આગામી",
    completed: "પૂર્ણ",
    live: "લાઈવ",
    ended: "સમાપ્ત",
    cancelled: "રદ",

    // Table headers
    colMeeting: "મીટિંગ",
    colTime: "સમય",
    colHost: "હોસ્ટ",
    colParticipants: "સહભાગીઓ",
    colStatus: "સ્ટેટસ",
    colAutoJoin: "ઓટો જોઈન",
    meetingSummary: "મીટિંગ સારાંશ",

    // Empty States & Filters
    noMeetingsMatchFilters: "કોઈ મીટિંગ્સ મળી નથી",
    noMeetingsMatchDescAutojoin: "મીટ AI ફક્ત આગામી Google કેલેન્ડર ઇવેન્ટ્સ બતાવે છે. અન્ય મીટિંગ્સ જોવા માટે 'બધી મીટિંગ્સ' અથવા 'બધી ટ્રાન્સક્રિપ્ટ્સ' ખોલો.",
    noMeetingsMatchDescGeneral: "દિવસ, સ્ટેટસ અથવા શોધ બદલો અથવા નીચે ફિલ્ટર્સ રીસેટ કરો.",
    noMeetingsInView: "કોઈ મીટિંગ્સ નથી",
    noMeetingsToday: "આજે કોઈ મીટિંગ નથી",
    noMeetings: "કોઈ મીટિંગ નથી",
    allDaysAllStatuses: "બધા દિવસો · બધી સ્થિતિઓ",
    clearSearch: "શોધ સાફ કરો",
    loadingGoogleCalendar: "Google કેલેન્ડર લોડ થઈ રહ્યું છે…",

    // Toggles & Actions
    on: "ચાલુ",
    off: "બંધ",
    rec: "REC",
    enabled: "ચાલુ",
    disabled: "બંધ",
    saving: "સેવ થઈ રહ્યું છે…",
    edit: "એડિટ",
    viewing: "જોઈ રહ્યા છો",
    saveChanges: "ફેરફારો સાચવો",
    cancel: "રદ કરો",

    // Settings modal
    manageSettingsSubtitle: "તમારી મીટિંગ પસંદગીઓ અને સેટિંગ્સ મેનેજ કરો",
    calendarSync: "કેલેન્ડર સમન્વયન",
    calendarConnected: "કનેક્ટેડ",
    calendarNeedsAttention: "ધ્યાન આપો",
    meetingReminders: "મીટિંગ રિમાઇન્ડર",
    minBefore: "મિનિટ પહેલાં",
    language: "ભાષા",
    turnOnRemindersPrompt: "મીટિંગ રિમાઇન્ડર ચાલુ કરો",
    turnOnRemindersDesc: "મીટિંગ શરૂ થવાના 10 મિનિટ પહેલાં સૂચના મેળવો.",
    maybeLater: "પછી",
    enableReminders: "રિમાઇન્ડર ચાલુ કરો",
  },

  Tamil: {
    // Nav
    instantJoin: "இன்ஸ்டன்ட் ஜாயின்",
        joinMeetAi: "Invite MeetAI",
        allTranscripts: "Recorded Meetings",
    dashboard: "டாஷ்போர்டு",
    calendar: "கேலெண்டர்",
    allMeetings: "அனைத்து மீட்டிங்ஸ்",
    myTasks: "என் டாஸ்க்குகள்",
    collapse: "சுருக்கு",
    expand: "விரிவாக்கு",

    // Header & Assistant
    searchMeetings: "மீட்டிங்ஸ் தேடுங்கள்",
    askYourCompanion: "அசிஸ்டெண்டிடம் கேளுங்கள்",
    refresh: "ரிஃப்ரெஷ்",
    howItWorks: "எப்படி வேலை செய்கிறது",
    logout: "லாக் அவுட்",
    profile: "சுயவிவரம்",
    settings: "செட்டிங்ஸ்",
    meetingUsage: "மீட்டிங் பயன்பாடு",
    feedback: "ஃபீட்பேக்",
    appTour: "ஆப் டூர்",
    adminPortal: "அட்மின் போர்டல்",

    // Time tabs & layout
    today: "இன்று",
    tomorrow: "நாளை",
    yesterday: "நேற்று",
    thisWeek: "இந்த வாரம்",
    nextWeek: "அடுத்த வாரம்",
    earlierThisWeek: "இந்த வார தொடக்கம்",
    lastWeek: "கடந்த வாரம்",
    later: "பிறகு",
    earlier: "முன்பு",
    unscheduled: "திட்டமிடப்படாதவை",
    week: "வாரம்",
    monthly: "மாதம்",
    list: "லிஸ்ட்",
    grid: "கிரிட்",
    all: "அனைத்தும்",
    allDays: "எல்லா நாட்களும்",
    done: "முடிந்தது",

    // Status
    upcoming: "அடுத்து வருபவை",
    completed: "முடிந்தவை",
    live: "லைவ்",
    ended: "முடிந்தவை",
    cancelled: "ரத்து செய்யப்பட்டவை",

    // Table headers
    colMeeting: "மீட்டிங்",
    colTime: "நேரம்",
    colHost: "ஹோஸ்ட்",
    colParticipants: "பங்கேற்பாளர்கள்",
    colStatus: "ஸ்டேட்டஸ்",
    colAutoJoin: "ஆட்டோ ஜாயின்",
    meetingSummary: "மீட்டிங் சுருக்கம்",

    // Empty States & Filters
    noMeetingsMatchFilters: "மீட்டிங்ஸ் எதுவும் இல்லை",
    noMeetingsMatchDescAutojoin: "Meet AI வரவிருக்கும் Google கேலெண்டர் நிகழ்வுகளை மட்டுமே காட்டுகிறது. மற்ற மீட்டிங்குகளுக்கு 'அனைத்து மீட்டிங்ஸ்' அல்லது 'அனைத்து டிரான்ஸ்கிரிப்ட்ஸ்' பார்க்கவும்.",
    noMeetingsMatchDescGeneral: "நாள், ஸ்டேட்டஸ் அல்லது தேடலை மாற்றவும் அல்லது கீழே ரீசெட் செய்யவும்.",
    noMeetingsInView: "மீட்டிங்ஸ் எதுவும் இல்லை",
    noMeetingsToday: "இன்று மீட்டிங்ஸ் இல்லை",
    noMeetings: "மீட்டிங்ஸ் இல்லை",
    allDaysAllStatuses: "எல்லா நாட்களும் · எல்லா ஸ்டேட்டஸும்",
    clearSearch: "தேடலை அழி",
    loadingGoogleCalendar: "Google கேலெண்டர் லோட் ஆகிறது…",

    // Toggles & Actions
    on: "ஆன்",
    off: "ஆஃப்",
    rec: "REC",
    enabled: "ஆன்",
    disabled: "ஆஃப்",
    saving: "சேமிக்கிறது…",
    edit: "எடிட்",
    viewing: "பார்க்கிறீர்கள்",
    saveChanges: "மாற்றங்களைச் சேமி",
    cancel: "ரத்து செய்",

    // Settings modal
    manageSettingsSubtitle: "உங்கள் மீட்டிங் விருப்பங்களையும் அமைப்புகளையும் நிர்வகியுங்கள்",
    calendarSync: "கேலெண்டர் சிங்க்",
    calendarConnected: "இணைக்கப்பட்டது",
    calendarNeedsAttention: "கவனம் தேவை",
    meetingReminders: "மீட்டிங் ரிமைண்டர்",
    minBefore: "நிமிடங்களுக்கு முன்",
    language: "மொழி",
    turnOnRemindersPrompt: "மீட்டிங் ரிமைண்டரை ஆன் செய்",
    turnOnRemindersDesc: "மீட்டிங் தொடங்குவதற்கு 10 நிமிடங்களுக்கு முன் நோட்டிபிகேஷன் பெறவும்.",
    maybeLater: "பிறகு",
    enableReminders: "ரிமைண்டரை ஆன் செய்",
  },

  Kannada: {
    // Nav
    instantJoin: "ಇನ್‌ಸ್ಟಂಟ್ ಜಾಯಿನ್",
        joinMeetAi: "Invite MeetAI",
        allTranscripts: "Recorded Meetings",
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    calendar: "ಕ್ಯಾಲೆಂಡರ್",
    allMeetings: "ಎಲ್ಲಾ ಮೀಟಿಂಗ್ಸ್",
    myTasks: "ನನ್ನ ಟಾಸ್ಕ್",
    collapse: "ಕುಗ್ಗಿಸಿ",
    expand: "ವಿಸ್ತರಿಸಿ",

    // Header & Assistant
    searchMeetings: "ಮೀಟಿಂಗ್ಸ್ ಹುಡುಕಿ",
    askYourCompanion: "ಸಹಾಯಕರನ್ನು ಕೇಳಿ",
    refresh: "ರಿಫ್ರೆಶ್",
    howItWorks: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
    logout: "ಲಾಗ್ ಔಟ್",
    profile: "ಪ್ರೊಫೈಲ್",
    settings: "ಸೆಟ್ಟಿಂಗ್ಸ್",
    meetingUsage: "ಮೀಟಿಂಗ್ ಬಳಕೆ",
    feedback: "ಪ್ರತಿಕ್ರಿಯೆ",
    appTour: "ಆ್ಯಪ್ ಟೂರ್",
    adminPortal: "ಅಡ್ಮಿನ್ ಪೋರ್ಟಲ್",

    // Time tabs & layout
    today: "ಇಂದು",
    tomorrow: "ನಾಳೆ",
    yesterday: "ನಿನ್ನೆ",
    thisWeek: "ಈ ವಾರ",
    nextWeek: "ಮುಂದಿನ ವಾರ",
    earlierThisWeek: "ಈ ವಾರದ ಆರಂಭದಲ್ಲಿ",
    lastWeek: "ಕಳೆದ ವಾರ",
    later: "ನಂತರ",
    earlier: "ಹಿಂದೆ",
    unscheduled: "ಅನ್‌ಶೆಡ್ಯೂಲ್ಡ್",
    week: "ವಾರ",
    monthly: "ಮಾಸಿಕ",
    list: "ಲಿಸ್ಟ್",
    grid: "ಗ್ರಿಡ್",
    all: "ಎಲ್ಲಾ",
    allDays: "ಎಲ್ಲಾ ದಿನಗಳು",
    done: "ಪೂರ್ಣಗೊಂಡಿದೆ",

    // Status
    upcoming: "ಮುಂಬರುವ",
    completed: "ಪೂರ್ಣಗೊಂಡಿದೆ",
    live: "ಲೈವ್",
    ended: "ಮುಕ್ತಾಯಗೊಂಡಿದೆ",
    cancelled: "ರದ್ದುಗೊಂಡಿದೆ",

    // Table headers
    colMeeting: "ಮೀಟಿಂಗ್",
    colTime: "ಸಮಯ",
    colHost: "ಆಯೋಜಕರು",
    colParticipants: "ಭಾಗವಹಿಸುವವರು",
    colStatus: "ಸ್ಥಿತಿ",
    colAutoJoin: "ಆಟೋ ಜಾಯಿನ್",
    meetingSummary: "ಮೀಟಿಂಗ್ ಸಾರಾಂಶ",

    // Empty States & Filters
    noMeetingsMatchFilters: "ಯಾವುದೇ ಮೀಟಿಂಗ್ಸ್ ಕಂಡುಬಂದಿಲ್ಲ",
    noMeetingsMatchDescAutojoin: "ಮೀಟ್ AI ಮುಂಬರುವ Google ಕ್ಯಾಲೆಂಡರ್ ಈವೆಂಟ್‌ಗಳನ್ನು ಮಾತ್ರ ತೋರಿಸುತ್ತದೆ. ಇತರ ಮೀಟಿಂಗ್ಸ್‌ಗಾಗಿ 'ಎಲ್ಲಾ ಮೀಟಿಂಗ್ಸ್' ಅಥವಾ 'ಎಲ್ಲಾ ಪ್ರತಿಲಿಪಿಗಳು' ನೋಡಿ.",
    noMeetingsMatchDescGeneral: "ದಿನ, ಸ್ಥಿತಿ ಅಥವಾ ಹುಡುಕಾಟವನ್ನು ಬದಲಾಯಿಸಿ ಅಥವಾ ಕೆಳಗೆ ಮರುಹೊಂದಿಸಿ.",
    noMeetingsInView: "ಯಾವುದೇ ಮೀಟಿಂಗ್ಸ್ ಇಲ್ಲ",
    noMeetingsToday: "ಇಂದು ಯಾವುದೇ ಮೀಟಿಂಗ್ಸ್ ಇಲ್ಲ",
    noMeetings: "ಮೀಟಿಂಗ್ಸ್ ಇಲ್ಲ",
    allDaysAllStatuses: "ಎಲ್ಲಾ ದಿನಗಳು · ಎಲ್ಲಾ ಸ್ಥಿತಿಗಳು",
    clearSearch: "ಹುಡುಕಾಟ ತೆರವುಗೊಳಿಸಿ",
    loadingGoogleCalendar: "Google ಕ್ಯಾಲೆಂಡರ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ…",

    // Toggles & Actions
    on: "ಆನ್",
    off: "ಆಫ್",
    rec: "REC",
    enabled: "ಆನ್",
    disabled: "ಆಫ್",
    saving: "ಉಳಿಸಲಾಗುತ್ತಿದೆ…",
    edit: "ಎಡಿಟ್",
    viewing: "ನೋಡಲಾಗುತ್ತಿದೆ",
    saveChanges: "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
    cancel: "ರದ್ದುಮಾಡಿ",

    // Settings modal
    manageSettingsSubtitle: "ನಿಮ್ಮ ಮೀಟಿಂಗ್ ಆದ್ಯತೆಗಳು ಮತ್ತು ಸೆಟ್ಟಿಂಗ್ಸ್ ನಿರ್ವಹಿಸಿ",
    calendarSync: "ಕ್ಯಾಲೆಂಡರ್ ಸಿಂಕ್",
    calendarConnected: "ಸಂಪರ್ಕಗೊಂಡಿದೆ",
    calendarNeedsAttention: "ಗಮನ ಬೇಕು",
    meetingReminders: "ಮೀಟಿಂಗ್ ಜ್ಞಾಪನೆ",
    minBefore: "ನಿಮಿಷಗಳ ಮೊದಲು",
    language: "ಭಾಷೆ",
    turnOnRemindersPrompt: "ಮೀಟಿಂಗ್ ಜ್ಞಾಪನೆಗಳನ್ನು ಆನ್ ಮಾಡಿ",
    turnOnRemindersDesc: "ಮೀಟಿಂಗ್ ಪ್ರಾರಂಭವಾಗುವ 10 ನಿಮಿಷಗಳ ಮೊದಲು ಸೂಚನೆ ಪಡೆಯಿರಿ.",
    maybeLater: "ನಂತರ",
    enableReminders: "ಜ್ಞಾಪನೆಗಳನ್ನು ಆನ್ ಮಾಡಿ",
  },

  Bengali: {
    // Nav
    instantJoin: "ইনস্ট্যান্ট জয়েন",
        joinMeetAi: "Invite MeetAI",
        allTranscripts: "Recorded Meetings",
    dashboard: "ড্যাশবোর্ড",
    calendar: "ক্যালেন্ডার",
    allMeetings: "সমস্ত মিটিং",
    myTasks: "আমার টাস্ক",
    collapse: "ছোট করুন",
    expand: "বড় করুন",

    // Header & Assistant
    searchMeetings: "মিটিং খুঁজুন",
    askYourCompanion: "সহকারীকে জিজ্ঞাসা করুন",
    refresh: "রিফ্রেশ",
    howItWorks: "এটি কীভাবে কাজ করে",
    logout: "লগ আউট",
    profile: "প্রোফাইল",
    settings: "সেটিংস",
    meetingUsage: "মিটিং ব্যবহার",
    feedback: "ফিডব্যাক",
    appTour: "অ্যাপ ট্যুর",
    adminPortal: "অ্যাডমিন পোর্টাল",

    // Time tabs & layout
    today: "আজ",
    tomorrow: "আগামীকাল",
    yesterday: "গতকাল",
    thisWeek: "এই সপ্তাহ",
    nextWeek: "পরের সপ্তাহ",
    earlierThisWeek: "এই সপ্তাহের শুরুতে",
    lastWeek: "গত সপ্তাহ",
    later: "পরে",
    earlier: "আগে",
    unscheduled: "আনশিডিউল্ড",
    week: "সপ্তাহ",
    monthly: "মাসিক",
    list: "লিস্ট",
    grid: "গ্রিড",
    all: "সমস্ত",
    allDays: "সমস্ত দিন",
    done: "সম্পন্ন",

    // Status
    upcoming: "আসন্ন",
    completed: "সম্পন্ন",
    live: "লাইভ",
    ended: "সমাপ্ত",
    cancelled: "বাতিল",

    // Table headers
    colMeeting: "মিটিং",
    colTime: "সময়",
    colHost: "হোস্ট",
    colParticipants: "অংশগ্রহণকারী",
    colStatus: "স্ট্যাটাস",
    colAutoJoin: "অটো জয়েন",
    meetingSummary: "মিটিং সারাংশ",

    // Empty States & Filters
    noMeetingsMatchFilters: "কোনো মিটিং পাওয়া যায়নি",
    noMeetingsMatchDescAutojoin: "মিট AI শুধুমাত্র আসন্ন Google ক্যালেন্ডার মিটিং দেখায়। অন্য মিটিংগুলির জন্য 'সমস্ত মিটিং' বা 'সমস্ত ট্রান্সক্রিপ্ট' দেখুন।",
    noMeetingsMatchDescGeneral: "দিন, স্ট্যাটাস বা অনুসন্ধান পরিবর্তন করুন অথবা নিচে রিসেট করুন।",
    noMeetingsInView: "কোনো মিটিং নেই",
    noMeetingsToday: "আজ কোনো মিটিং নেই",
    noMeetings: "কোনো মিটিং নেই",
    allDaysAllStatuses: "সমস্ত দিন · সমস্ত স্ট্যাটাস",
    clearSearch: "অনুসন্ধান সাফ করুন",
    loadingGoogleCalendar: "Google ক্যালেন্ডার লোড হচ্ছে…",

    // Toggles & Actions
    on: "অন",
    off: "অফ",
    rec: "REC",
    enabled: "চালু",
    disabled: "বন্ধ",
    saving: "সংরক্ষণ করা হচ্ছে…",
    edit: "এডিট",
    viewing: "দেখছেন",
    saveChanges: "পরিবর্তন সেভ করুন",
    cancel: "বাতিল",

    // Settings modal
    manageSettingsSubtitle: "আপনার মিটিং পছন্দসমূহ পরিচালনা করুন",
    calendarSync: "ক্যালেন্ডার সিঙ্ক",
    calendarConnected: "কানেক্টেড",
    calendarNeedsAttention: "মনোযোগ প্রয়োজন",
    meetingReminders: "মিটিং রিমাইন্ডার",
    minBefore: "মিনিট আগে",
    language: "ভাষা",
    turnOnRemindersPrompt: "মিটিং রিমাইন্ডার চালু করুন",
    turnOnRemindersDesc: "মিটিং শুরু হওয়ার 10 মিনিট আগে বিজ্ঞপ্তি পান।",
    maybeLater: "পরে",
    enableReminders: "রিমাইন্ডার সক্ষম করুন",
  },
};

/**
 * Helper to get translation for a key and language.
 */
export function getTranslation(lang, key, fallback = "") {
  const selectedLang = String(lang || "English").trim();
  const dict = TRANSLATIONS[selectedLang] || TRANSLATIONS.English;
  if (dict && dict[key] != null) {
    return dict[key];
  }
  const eng = TRANSLATIONS.English;
  return eng[key] != null ? eng[key] : (fallback || key);
}
